import { render } from "./index.vue?vue&type=template&id=51fbbd94&scoped=true&lang=pug"
import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=51fbbd94&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-51fbbd94"

export default script